export enum Roles {
  regularUser = 'regular-user',
  companyAdministrator = 'company-administrator',
  superAdmin = 'super-admin',
}



        